import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IJourney } from '@/modules/journey/model';
import { DescriptionList } from '@/shared/view/DescriptionList';

import s from './styles.module.css';

const Breakdown = ({ journey }: { journey: IJourney }) => {
  const intl = useIntl();

  const { titles, values } = useMemo(() => {
    const priceDetails = (journey.breakdown || []).map(breakdownItem => ({
      key: breakdownItem.name,
      label: breakdownItem.name,
      value: intl.formatNumber(breakdownItem.value, {
        style: 'currency',
        currency: journey.currencyCode,
      }),
    }));

    if (journey.isTotalDefined) {
      priceDetails.push({
        key: 'total',
        label: intl.formatMessage({
          defaultMessage: 'Total',
          id: '6WajoZ',
          description: 'Journey screen: Total field title',
        }),
        value: intl.formatNumber(journey.price as number, {
          style: 'currency',
          currency: journey.currencyCode,
        }),
      });
    }

    return {
      titles: priceDetails.map(
        priceDetail => [priceDetail.key, priceDetail.label] as [string, string],
      ),
      values: priceDetails.reduce(
        (priceDetailsValues, priceDetail) => {
          priceDetailsValues[priceDetail.key] = priceDetail.value;

          return priceDetailsValues;
        },
        {} as Record<string, string>,
      ),
    };
  }, [intl, journey.breakdown, journey.price, journey.currencyCode, journey.isTotalDefined]);

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Breakdown',
        id: 'WjiNlv',
        description: 'Journey screen: Breakdown section title',
      })}
      titles={titles}
      values={values}
      className={s.details}
    />
  );
};

export { Breakdown };
